import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCookie } from 'react-icons/fa';
import './CookieConsentBanner.css';

/**
 * CookieConsentBanner component - Displays a cookie consent banner on first visit
 * Stores user consent in localStorage and provides link to full Cookie Policy
 * @returns {JSX.Element|null} The rendered cookie consent banner or null if already accepted
 */
const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const CONSENT_KEY = 'ai-fire-defense-cookie-consent';

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  /**
   * Handles user accepting all cookies
   * Stores consent in localStorage and hides banner
   * @returns {void}
   */
  const handleAcceptAll = () => {
    localStorage.setItem(CONSENT_KEY, 'all');
    setIsVisible(false);
  };

  /**
   * Handles user accepting only necessary cookies
   * Stores consent in localStorage and hides banner
   * @returns {void}
   */
  const handleAcceptNecessary = () => {
    localStorage.setItem(CONSENT_KEY, 'necessary');
    setIsVisible(false);
  };

  /**
   * Navigates to the full Cookie Policy page
   * @returns {void}
   */
  const handleLearnMore = () => {
    navigate('/cookie-policy');
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-icon">
          <FaCookie />
        </div>
        <div className="cookie-consent-content">
          <h3>We Value Your Privacy</h3>
          <p>
            We use cookies to enhance your browsing experience, analyze site traffic,
            and provide personalized content. By clicking "Accept All", you consent to
            our use of cookies.
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button
            className="cookie-consent-button cookie-consent-learn-more"
            onClick={handleLearnMore}
          >
            Learn More
          </button>
          <button
            className="cookie-consent-button cookie-consent-necessary"
            onClick={handleAcceptNecessary}
          >
            Accept Necessary Only
          </button>
          <button
            className="cookie-consent-button cookie-consent-accept"
            onClick={handleAcceptAll}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
